"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFindGroup = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useFindGroup(id) {
    const { data, isLoading, error, get } = (0, core_ui_1.useApiGet)(`groups/${id}`);
    return { group: data, isLoading, error, get };
}
exports.useFindGroup = useFindGroup;
//# sourceMappingURL=useFindGroup.js.map